import { get } from 'lodash';
import { retrieveObjectMapper } from '../..';

export const transformConfigByCategory = (apiResponse = {}) => {
  return {
    totalCount: get(apiResponse, 'totalCount', 0) || 0,
    data: (get(apiResponse, 'data', []) || []).map(item =>
      retrieveObjectMapper(item, [
        'ID:id',
        'fk_school',
        'label',
        'description',
        'active',
        'created_at',
        'updated_at',
        'display',
      ])
    ),
  };
};

export default {
  transformConfigByCategory,
};
